import type { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
import type { SkipTokenRefreshConfig } from "./Plugin/RefreshToken/RefreshTokenResponseInterceptor";
import { AxiosHeaders } from "axios";

/**
 * The header that carries the hash of a guest link (`/p/report/{hash}`) to the public API v1. The hash is a credential
 * of its own: the API answers 401 when a request sends it together with an access token, and a 401 on it means the
 * link is not valid, never that a token expired.
 */
export const GUEST_LINK_HEADER = "X-Verbleif-App-Subscription";

/**
 * The request config of a call made with a guest link: the hash in its header, and no token refresh on a 401. Every
 * guest link call goes through this, so the access token of a signed in employee never travels with it.
 */
export function guestLinkRequestConfig(hash: string): AxiosRequestConfig & SkipTokenRefreshConfig {
  return {
    headers: { [GUEST_LINK_HEADER]: hash },
    skipTokenRefresh: true,
  };
}

/** Whether a request authenticates with a guest link, so it must not also send the access token. */
export function isGuestLinkRequest(config: InternalAxiosRequestConfig): boolean {
  return AxiosHeaders.from(config.headers).has(GUEST_LINK_HEADER);
}
